import { Component, OnInit } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { GasTravel } from 'src/app/models/gas-travel';
import { TravelService } from 'src/app/services/travel.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgbDateAdapter, NgbTimepickerConfig, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';

@Component({
  selector: 'app-gas-ticket-emmit',
  templateUrl: './gas-ticket-emmit.component.html',
  styleUrls: ['./gas-ticket-emmit.component.css'],
  providers: [
    { provide: NgbDateAdapter, useClass: NativeDateAdapter },
    NgbTimepickerConfig
  ]
})
export class GasTicketEmmitComponent implements OnInit {

  lts = 0;
  lts_2 = 0;
  lts_loaded = 0;
  lts_loaded_2 = 0;
  travel_id: number;
  travel: Travel;
  gasTravel : GasTravel;
  loading: boolean = false;
  canEmmitR: boolean = false;
  canEmmitT: boolean = false;
  typeOfgas: number = 0;
  gasType: string = 'proeco';

  constructor(private travelServ: TravelService, private toastr: ToastrManager) { }

  ngOnInit() {
  }

  search(event) {
    event.preventDefault();
    this.loading = true;
    this.travelServ.getTravel(this.travel_id).then(tr => {
      this.travel = tr;
      this.lts = this.travel.expenses
        .filter(exp => exp.expense_name == 'SUPER DIESEL' || exp.expense_name == 'EXTRA GASOLINA')
        .map(exp => exp.quantity)
        .reduce((ant, act) => {
          return Number(ant) + Number(act);
        }, 0);
      this.lts_2 = this.travel.expenses
        .filter(exp => exp.expense_name == 'SUPER DIESEL EXTRA')
        .map(exp => exp.quantity)
        .reduce((ant, act) => {
          return Number(ant) + Number(act);
        }, 0);
      this.lts_loaded = this.travel.gas_travel.filter(x => !x.is_refill).map(x => x.metric_real).reduce((a, b) => Number(a) + Number(b), 0);
      this.lts_loaded_2 = this.travel.gas_travel.filter(x => x.is_refill).map(x => x.metric_real).reduce((a, b) => Number(a) + Number(b), 0);

      this.travel.gas_date_proeco = this.travel.gas_date_proeco ? new Date(this.travel.gas_date_proeco) : new Date();
      this.travel.gas_date_proeco_2 = this.travel.gas_date_proeco_2 ? new Date(this.travel.gas_date_proeco_2) : new Date();

      // this.canEmmitT = (tr.gas_metric_initial == 0 ? true : false) && tr.newticket;
      // this.canEmmitR = (tr.gas_metric_initial_2 == 0 ? true : false) && tr.newticket;
      this.checkEmmit(this.typeOfgas);

      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("Viaje no encontrado!");
      this.loading = false;
    });
  }

  save(event) {
    event.preventDefault();

    let custom_travel = {
      id: this.travel.id, 
      gas_metric_initial: this.travel.gas_metric_initial, 
      gas_metric_final: this.travel.gas_metric_final, 
      gas_date: this.travel.gas_date_proeco, 
      gas_description: this.travel.gas_description_proeco, 
      type: this.typeOfgas, 
      lts: this.lts, 
      lts_2: this.lts_2, 
      lts_loaded: this.lts_loaded, 
      lts_loaded_2: this.lts_loaded_2,
      gas_type: this.gasType,
    };

    var validation_success = false;
    var forms = document.getElementsByClassName('needs-validation');
    Array.prototype.filter.call(forms, (form) => {
      if (form.checkValidity() === false) {
        event.stopPropagation();
        validation_success = false;
      } else {
        validation_success = true;
      }
      form.classList.add('was-validated');
    });

    if (validation_success) {
      this.loading = true;
      this.travelServ.postRealGas(this.travel, custom_travel).then(resp => {
        this.toastr.successToastr("Información actualizada correctamente");
        this.search(event);
      }).catch(e => {
        (e.error.errors)?this.toastr.errorToastr(e.error.errors):this.toastr.errorToastr("Todos los datos son obligatorios");
        this.loading = false;
      });
    }
  }

  checkEmmit(typeofgas) {
    this.travelServ.getCheckEmmit(this.travel.id, typeofgas).then( resp  => {
      this.gasTravel = resp;
      if (this.gasTravel.length == 1) {
        this.canEmmitT = false
        this.travel.gas_metric_initial = resp[0].metric_initial;
        this.travel.gas_metric_final = resp[0].metric_final;
        this.travel.gas_date_proeco = new Date(resp[0].gas_date);
        this.travel.gas_description_proeco = resp[0].description;
      } else {
        this.canEmmitT = true;
        this.travel.gas_metric_initial = 0;
        this.travel.gas_metric_final = 0;
        this.travel.gas_date_proeco = new Date();
        this.travel.gas_description_proeco = null;
      }
    }).catch(e => {
      this.toastr.errorToastr("Todos los datos son obligatorios");
      this.loading = false;
    });
  }
}
